
import $http from "@/plugins/axios.js"
import  router  from '@/router/index.js'

export default {
    state:{
        userInfo:{},
        permissions: JSON.parse(localStorage.getItem('permissions') || "[]"),
        roles:JSON.parse(localStorage.getItem('roles') || "[]"),
    },
    getters:{
        userInfo: state =>  state.userInfo,
        permissions: state =>  state.permissions,
        roles: state =>  state.roles
    },
    actions:{
        async checkAuth({commit}){
            const response = await $http.get('/auth/details')
            .catch(()=>{
                localStorage.removeItem('userData')
                localStorage.removeItem('accessToken')
                router.push('/login')
            })
            commit('SET_PERMISSIONS',response.data)
            commit('SET_ROLES',response.data)
            return commit
        },
        async logout({commit}){
            await $http.post('/user/logout')
            return commit
        },
    },
    mutations:{
        
        SET_USER(state,data){
            state.userInfo = data
            localStorage.setItem('userData',JSON.stringify(data))
        },
        SET_PERMISSIONS(state, data){
            state.permissions = data.all_permissions
            localStorage.setItem("permissions",JSON.stringify(data.all_permissions))
        },
        SET_ROLES(state, data){
            state.roles = data.roles
            localStorage.setItem("roles",JSON.stringify(data.roles))
        }
    }
}